import { ApplicationController } from "../application_controller";
import BSN from "bootstrap.native"
import Rails from "@rails/ujs"
import Tabulator from "tabulator-tables";
import AutoNumeric from 'autonumeric';
import nerdamer from "nerdamer/nerdamer.core"
import { Draggable } from 'agnostic-draggable';

export default class extends ApplicationController {
  static targets = ["price_by_group_field", "show_all_seasons",
    "modal_currency_field", "seasons_fields", "checkbox_price_by_group", "tourist_amount",
    "room_prices_field", "seasons_grp_fields", "table",
    "fit_destroy", "grp_destroy", "group_destroy", "room_modal_xl", "room_modal_md", "room_modal_md_second",
    "main_form", "groups_fields",
    "season_hidden_row"]

  connect() {
    // Main table
    if (this.hasTableTarget) {
      const content_url = this.data.get("table-load-url");
      this.createTable(content_url);
    }
    
    // Initialize seasons filter state
    this.initializeSeasonsFilter()

    if (this.hasRoom_modal_xlTarget) {
      window.room_modal_xl = new BSN.Modal(this.room_modal_xlTarget, {
        backdrop: "static",
        keyboard: true
      });
    }

    if (this.hasRoom_modal_mdTarget) {
      window.room_modal_md = new BSN.Modal(this.room_modal_mdTarget, {
        backdrop: "static",
        keyboard: true
      });
    }

    if (this.hasRoom_modal_md_secondTarget) {
      window.room_modal_md_second = new BSN.Modal(this.room_modal_md_secondTarget, {
        backdrop: "static",
        keyboard: true
      });
    }

    // Main Form
    if (this.hasMain_formTarget) {
      this.addReloadFormTrigger(this.main_formTarget)
    }
  }

  tableRelod(event) {
    const table_target = document.getElementById("rooms_table")
    const supplier_tab_services = document.getElementById("supplier_tab_services")
    const content_url = supplier_tab_services.getAttribute("data-suppliers--rooms-table-load-url");
    // const content_url = this.data.get("table-load-url");
    table_target.tabulator.setData(content_url);
  }

  initializeSeasonsFilter() {
    const showAllSeasonsCheckbox = document.querySelector('input[name="room[show_all_seasons]"]')
    if (showAllSeasonsCheckbox && !showAllSeasonsCheckbox.checked) {
      this.season_hidden_rowTargets.forEach(el => {
        el.classList.add("season-hidden-column")
        el.classList.remove("show-all-seasons")
      })
    }
  }

  onShowAllSeasons(event){
    if (event.target.checked) {
      this.season_hidden_rowTargets.forEach(el => {
        el.classList.remove("season-hidden-column")
        el.classList.add("show-all-seasons")
      })
    } else {
      this.season_hidden_rowTargets.forEach(el => {
        el.classList.add("season-hidden-column")
        el.classList.remove("show-all-seasons")
      })
    }
  }


  toggleSeasons(event) {
    let tr = event.currentTarget.closest('.tabulator-row')
    let icon = event.currentTarget.querySelector('i')
    if (tr) tr.classList.toggle("show-child-table")
    if (icon) {
      if (icon.classList.contains("fa-angle-down")) {
        icon.classList.remove("fa-angle-down")
        icon.classList.add("fa-angle-up")
      } else {
        icon.classList.remove("fa-angle-up")
        icon.classList.add("fa-angle-down")
      }
    }
  }

  // Create main table
  async createTable(url) {
    const columns = this.data.get("table-columns");
    const table_target = this.tableTarget;
    const default_props = super.tabulatorDefaultProps
    const height = document.getElementById('content').clientHeight;
    const table_id = this.data.get("table-id");
    const locale = super.appLocale;

    let addSeasons = this.addRoomSeasonsTable

    let table_props = {
      virtualDomHoz: false,
      virtualDomBuffer: 3000,
      index: "id",
      height: (height - 200) + "px",
      persistenceID: table_id,
      movableColumns: true,
      // columns
      columns: JSON.parse(columns),
      // sort
      headerSort: false,
      // initialSort: [
      //   { column: sort_column, dir: sort_dir }
      // ],

      // Ajax
      ajaxURL: url,
      ajaxSorting: true,
      ajaxLoader: true,
      ajaxLoaderLoading: "<div class='loader' > Loading...</div> ",

      rowFormatter: function (row) {
        const data = row.getData()

        if (data.seasons_table && data.seasons_table.data && data.seasons_table.data.length > 0) {
          addSeasons(row, data.seasons_table.columns, data.seasons_table.data)
        }
      }
    }

    table_props = Object.assign(default_props, table_props);
    // create table
    table_target.tabulator = new Tabulator(table_target, table_props);
    table_target.tabulator.setLocale(super.appLocale);
  }

  addRoomSeasonsTable(row, columns, table_data) {
    //create and style holder elements
    let holderEl = document.createElement("div");
    holderEl.classList = "child-table rooms-seasons-table";
    holderEl.style.padding = "0 0 10px 20px";
    let tableEl = document.createElement("div");
    holderEl.appendChild(tableEl);

    row.getElement().appendChild(holderEl);

    if (table_data && table_data.length > 0) {
      tableEl.tabulator = new Tabulator(tableEl, {
        layout: "fitData", // Prevents horizontal scroll flickering (GitHub Issue #3856)
        data: table_data,
        headerSort: false,
        columns: columns,
        responsiveLayout: false, // Key fix for scrollbar flashing in Chrome
        rowFormatter: function(childRow) {
          const childData = childRow.getData();
          const cells = childRow.getCells();
          // Apply styling classes to each cell based on value
          cells.forEach(cell => {
            const field = cell.getField();
            const value = cell.getValue();
            const price_class = childData[`${field}_price_class`];
            // Skip first column (group_type)
            if (field !== 'group_type' && value !== undefined) {
              cell.getElement().classList.add(price_class);
            }
          });
        }
      })
    }
  }




  // actions
  // priceFocusout(event) {
  //   let code = (event.keyCode ? event.keyCode : event.which);
  //   if (code == 9) {
  //     event.preventDefault();
  //     return;
  //   }
  // }

  priceChange(event) {
    const tr = event.currentTarget.closest("tr");
    const price_input = tr.querySelector("input.price_input")
    let vat_value = 0, price_with_vat_value = 0, total_value = 0;
    if (!price_input)
      return;
    if (price_input.value) {
      let price = parseFloat(price_input.value.replace(/\s/g, '').replace(",", '.').replace(/[^\d.-]/g, ''))
      vat_value = this.getVatValueFromPrice(price)
      price_with_vat_value = this.getPriceWithVatValueFromPrice(tr, price)
    }
    // change vat
    this.setVatHtml(tr, vat_value)
    // change price_with_vat_value
    this.setPriceWithVatValue(tr, price_with_vat_value)
    // change total sum
    total_value = this.getTotalValue(tr);
    this.setTotalHtml(tr, total_value)
  }

  isVatChange(event) {
    const tr = event.currentTarget.closest("tr");
    const price_input = tr.querySelector("input.price_input")
    let vat_value = 0, price_with_vat_value = 0, total_value = 0;
    if (!price_input)
      return;
    if (price_input.value) {
      let price = parseFloat(price_input.value.replace(/\s/g, '').replace(",", '.').replace(/[^\d.-]/g, ''))
      vat_value = this.getVatValueFromPrice(price)
      price_with_vat_value = this.getPriceWithVatValueFromPrice(tr, price)
    }
    // change vat
    this.setVatHtml(tr, vat_value)
    // change price_with_vat_value
    this.setPriceWithVatValue(tr, price_with_vat_value)
    // change total sum
    total_value = this.getTotalValue(tr);
    this.setTotalHtml(tr, total_value)

  }

  priceWithVatChange(event) {
    const tr = event.currentTarget.closest("tr");
    const price_with_vat_input = tr.querySelector("input.price_with_vat_input")
    let vat_value = 0, price_value = 0, total_value = 0;
    if (!price_with_vat_input)
      return;
    if (price_with_vat_input.value) {
      let price_with_vat = parseFloat(price_with_vat_input.value.replace(/\s/g, '').replace(",", '.').replace(/[^\d.-]/g, ''))
      vat_value = this.getVatValueFromPriceWithVat(price_with_vat)
      price_value = this.getPriceValueFromPriceWithVat(tr, price_with_vat)
    }
    // change vat
    this.setVatHtml(tr, vat_value)
    // change price_with_vat_value
    this.setPriceValue(tr, price_value)
    const price_input = tr.querySelector("input.price_input")
    // change total sum
    total_value = this.getTotalValue(tr);
    this.setTotalHtml(tr, total_value)
  }

  isTouristAmountChange(event) {
    this.recalculate_table();
    
    this.updateDailyPriceEditorTouristTax();
  }

  isTouristTaxChange(event) {
    const tr = event.currentTarget.closest("tr");
    let total_value = 0;
    // change total sum
    total_value = this.getTotalValue(tr);
    this.setTotalHtml(tr, total_value)
  }

  isExtraSumChange(event) {
    const tr = event.currentTarget.closest("tr");
    const extra_sum_input = tr.querySelector("input.extra_sum_input");
    const is_extra_sum_checkbox = tr.querySelector("input.is_extra_sum_checkbox");
    
    // Enable/disable extra sum input based on checkbox
    if (extra_sum_input && is_extra_sum_checkbox) {
      extra_sum_input.disabled = !is_extra_sum_checkbox.checked;
      if (!is_extra_sum_checkbox.checked) {
        extra_sum_input.value = "";
      }
    }
    
    let total_value = 0;
    // change total sum
    total_value = this.getTotalValue(tr);
    this.setTotalHtml(tr, total_value)
  }

  extraSumFormulaChange(event) {
    const tr = event.currentTarget.closest("tr");
    const extra_sum_input = tr.querySelector("input.extra_sum_input")
    let formula_value = 0, total_value = 0;
    if (!extra_sum_input)
      return;
    if (extra_sum_input.value) {
      formula_value = this.getExtraSumFormula(tr);
    }
    // change total sum
    total_value = this.getTotalValue(tr);
    this.setTotalHtml(tr, total_value)
  }

  // TOTAL
  // set
  setTotalHtml(tr, total_value) {
    const html = tr.querySelector(".room_season_total")
    if (!html)
      return;
    html.innerHTML = this.setFormat(total_value);
  }
  // get
  getTotalValue(tr) {
    let price_with_vat = this.getPriceWithVatValue(tr)
    let tourist_tax = this.getTouristTaxValue();
    let extra_sum = this.getExtraSumFormula(tr);
    const is_tourist_tax_checkbox = tr.querySelector("input.is_tourist_tax_checkbox")
    const is_tourist_tax = is_tourist_tax_checkbox.checked
    const is_extra_sum_checkbox = tr.querySelector("input.is_extra_sum_checkbox")
    const is_extra_sum = is_extra_sum_checkbox.checked

    if (!is_tourist_tax) tourist_tax = 0;
    if (!is_extra_sum) extra_sum = 0;
    return price_with_vat + tourist_tax + extra_sum
  }


  // // FORMULA
  // get
  getExtraSumFormula(tr) {
    const extra_sum_input = tr.querySelector("input.extra_sum_input")
    let formula_value = 0;
    try {
      let e = nerdamer(extra_sum_input.value);
      formula_value = e.evaluate();
    } catch (e) {
      extra_sum_input.setCustomValidity("");
      // expected output: "Parameter is not a number!"
    }
    return formula_value;
  }
  // set
  setPriceValue(tr, price_value) {
    const price_input = tr.querySelector("input.price_input")
    if (!price_input)
      return;
    price_input.value = this.setFormat(price_value);
  }


  // //       tourist_tax        // //
  // get
  getTouristTaxValue() {
    const tax_values = JSON.parse(this.data.get("bvr-currency-rates"))
    let current_currency = document.querySelector('input[name="room[price_currency]"]:checked').value;
    let tourist_amount = this.tourist_amountTarget.value || 0;
    const currencyRate = tax_values && tax_values[current_currency] ? tax_values[current_currency] : 0;
    const value = tourist_amount * parseFloat(currencyRate.toString())
    return value;
  }

  // set
  setTouristTaxHtml(tr) {
    const is_tourist_tax_checkbox = tr.querySelector("input.is_tourist_tax_checkbox");
    const html = tr.querySelector(".tourist_tax_value");
    
    if (!html) return;
    
    let value = 0;
    if (is_tourist_tax_checkbox && is_tourist_tax_checkbox.checked) {
      value = this.getTouristTaxValue();
    }
    
    html.innerHTML = this.setFormat(value);
  }

  // //       VAT        // //
  // get
  getVatValueFromPrice(price_value) {
    const vat_percent = parseFloat(this.data.get("vat-percent"))
    const vat_value = price_value * vat_percent / 100;
    return vat_value;
  }
  // get
  getVatValueFromPriceWithVat(price_with_value) {
    const vat_percent = parseFloat(this.data.get("vat-percent"))
    const vat_value = price_with_value * vat_percent / (100 + vat_percent);
    return vat_value;
  }
  // set
  setVatHtml(tr, vat_value) {
    const vat_html = tr.querySelector(".vat_value")
    if (!vat_html)
      return;
    vat_html.innerHTML = this.setFormat(vat_value);
  }
  // // // // // // // // // // //

  // // Price
  // get
  getPriceValueFromPriceWithVat(tr, price_with_vat) {
    const vat_value = this.getVatValueFromPriceWithVat(price_with_vat)
    const is_vat_checkbox = tr.querySelector("input.is_vat_checkbox")
    const is_vat = is_vat_checkbox.checked
    // price_with_vat_value
    let price_value = 0
    if (is_vat) price_value = price_with_vat - vat_value;
    else price_value = price_with_vat;
    return price_value;
  }
  // set
  setPriceValue(tr, price_value) {
    const price_input = tr.querySelector("input.price_input")
    if (!price_input)
      return;
    // price_input.value = this.setFormat(price_value);
    price_input.numeric.set(price_value);
  }

  // //          PriceWithVat           //  //
  // get value
  getPriceWithVatValue(tr) {
    const price_input = tr.querySelector("input.price_input")
    if (!price_input || !price_input.value)
      return 0;
    
    let price = parseFloat(price_input.value.replace(/\s/g, '').replace(",", '.').replace(/[^\d.-]/g, '')) || 0;
    return this.getPriceWithVatValueFromPrice(tr, price);
  }

  getPriceWithVatValueFromPrice(tr, price_value) {
    const vat_value = this.getVatValueFromPrice(price_value)
    const is_vat_checkbox = tr.querySelector("input.is_vat_checkbox")
    const is_vat = is_vat_checkbox.checked
    // price_with_vat_value
    let price_with_vat_value = 0
    if (is_vat) price_with_vat_value = price_value + vat_value;
    else price_with_vat_value = price_value;
    return price_with_vat_value;
  }
  // set html
  setPriceWithVatValue(tr, price_with_vat_value) {
    const price_with_vat_display = tr.querySelector(".price_with_vat_display")
    if (!price_with_vat_display)
      return;
    price_with_vat_display.textContent = this.setFormat(price_with_vat_value);
  }

  setFormat(value) {
    if (!value)
      return 0;
    return AutoNumeric.format(value, {
      allowDecimalPadding: "floats",
      decimalPlaces: 2,
      digitGroupSeparator: " ",
      decimalCharacter: ".",
      decimalCharacterAlternative: ",",
      styleRules: {
        positive: "autoNumeric-positive"
      },
      minimumValue: 0
    });
  }

  updateCurrencyFields(event) {
    const currency = event.currentTarget.getAttribute("value");
    this.modal_currency_fieldTargets.forEach(el => {
      el.innerHTML = currency;
    });

    this.recalculate_table();

  }

  recalculate_table(){

    const fit_tbody = document.getElementById('fit_rooms_tbody');
    const grp_tbody = document.getElementById('grp_rooms_tbody');

    // Check and process fit_tbody if exists
    if (fit_tbody && fit_tbody.rows) {
      for (let i = 0; i < fit_tbody.rows.length; i++) {
        if (fit_tbody.rows[i]) {
          let tr = fit_tbody.rows[i];
          this.setTouristTaxHtml(tr)
          const total_value = this.getTotalValue(tr)
          this.setTotalHtml(tr, total_value)
        }
      }
    }

    // Check and process grp_tbody if exists
    if (grp_tbody && grp_tbody.rows) {
      for (let i = 0; i < grp_tbody.rows.length; i++) {
        if (grp_tbody.rows[i]) {
          let tr = grp_tbody.rows[i];
          this.setTouristTaxHtml(tr)
          const total_value = this.getTotalValue(tr)
          this.setTotalHtml(tr, total_value)
        }
      }
    }

    // If no tables found by ID, look for group price rows (for groups-only mode)
    if (!fit_tbody && !grp_tbody) {
      const groupRows = document.querySelectorAll('tr[data-group-type]');
      
      groupRows.forEach((tr) => {
        this.setTouristTaxHtml(tr);
        const total_value = this.getTotalValue(tr);
        this.setTotalHtml(tr, total_value);
      });
    }

  }

  // нажатие на включение разделение по группам
  setPriceByGroup(event) {
    this.disableEnableSeasonGroupForms()
  }

  // логика переключения форм сезонов
  disableEnableSeasonGroupForms() {
    const is_price_by_group = this.checkbox_price_by_groupTarget.checked

    // Определяем режим на основе состояния переключателей
    const mode = this.determinePricingMode(is_price_by_group, true) // is_price_by_season всегда true
    const config = this.getPricingConfig(mode)

    // Применяем конфигурацию
    this.applyPricingConfig(config)
  }

  // Определение режима ценообразования
  determinePricingMode(is_price_by_group, is_price_by_season) {
    // is_price_by_season всегда true для новых записей
    if (is_price_by_group) return 'combined'
    return 'seasons_only'
  }

  // Конфигурации для каждого режима
  getPricingConfig(mode) {
    const configs = {
      combined: {
        showAllSeasonsButton: true,
        showGroupForm: false,
        showSeasonsForm: true,
        showSeasonsGroupForm: true,
        disablePriceByGroup: false,
        showDailyPriceEditor: false,
        showPricingContainer: true,
        destroyStates: { grp: false, fit: false, group: true }
      },
      seasons_only: {
        showAllSeasonsButton: true,
        showGroupForm: false,
        showSeasonsForm: true,
        showSeasonsGroupForm: false,
        disablePriceByGroup: true,
        showDailyPriceEditor: false,
        showPricingContainer: true,
        destroyStates: { grp: true, fit: false, group: true }
      }
    }
    return configs[mode]
  }

  // Применение конфигурации
  applyPricingConfig(config) {
    this.showAllSeasonsButton(config.showAllSeasonsButton)
    this.showGroupForm(config.showGroupForm)
    this.showSeasonsForm(config.showSeasonsForm)
    this.showSeasonsGroupForm(config.showSeasonsGroupForm)
    this.disableEnablePriceByGroup(config.disablePriceByGroup)
    this.showHidePricingContainer(config.showPricingContainer)
    
    this.hideDailyPriceEditor()
    
    // Применяем destroy состояния
    Object.entries(config.destroyStates).forEach(([type, destroy]) => {
      this.setDestroyEnableDisableRommSeason(destroy, type)
    })
  }

  // поля от до
  disableEnablePriceByGroup(is_disabled) {
    const price_by_groupField = this.price_by_group_fieldTarget;
    price_by_groupField.disabled = is_disabled;
  }

  // _destroy = true
  setDestroyEnableDisableRommSeason(is_destroy, group_type) {
    let allFields
    if (group_type == "grp") allFields = this.grp_destroyTargets;
    else if (group_type == "group") allFields = this.group_destroyTargets;
    else allFields = this.fit_destroyTargets;

    if (allFields) {
      allFields.forEach((field) => {
        field.value = is_destroy;
      });
    }
  }

  // показывам строку GRP в таблице сезонов
  showSeasonsGroupForm(is_show) {
    if (this.hasSeasons_grp_fieldsTarget) {
      if (is_show) {
        this.seasons_grp_fieldsTarget.classList.remove("hidden");
      } else {
        this.seasons_grp_fieldsTarget.classList.add("hidden");
      }
    }
  }

  showAllSeasonsButton(is_show) {
    if (is_show) this.show_all_seasonsTarget.classList.remove("hidden");
    else this.show_all_seasonsTarget.classList.add("hidden");
  }

  // поле цена
  disableEnablePriceField(is_disabled) {
    this.price_fieldTarget.disabled = is_disabled;
  }

  disableEnableExtraPriceField(is_disabled) {
    this.extra_price_fieldTarget.disabled = is_disabled;
  }

  // disableEnablePriceField(is_disabled) {
  //   this.price_fieldTarget.disabled = is_disabled;
  // }

  // показывам таблицу с полями для сезона
  showSeasonsForm(is_show) {
    if (is_show) this.seasons_fieldsTarget.classList.remove("hidden");
    else this.seasons_fieldsTarget.classList.add("hidden");
  }

  showGroupForm(is_show) {
    if (is_show) this.groups_fieldsTarget.classList.remove("hidden");
    else this.groups_fieldsTarget.classList.add("hidden");
  }

  showHidePricingContainer(is_show) {
    const pricingContainer = document.querySelector('#supplier_room_pricing_form');
    if (pricingContainer) {
      if (is_show) {
        pricingContainer.classList.remove("hidden");
      } else {
        pricingContainer.classList.add("hidden");
      }
    }
  }

  showHideDailyPriceEditor(is_show) {
    const dailyPriceEditor = document.querySelector('#daily_price_editor');
    if (dailyPriceEditor) {
      if (is_show) {
        dailyPriceEditor.classList.remove("d-none");
      } else {
        dailyPriceEditor.classList.add("d-none");
      }
    }
  }

  hideDailyPriceEditor() {
    const dailyPriceEditor = document.querySelector('#daily_price_editor');
    if (dailyPriceEditor) {
      dailyPriceEditor.classList.add("d-none");
    }
  }

  //
  // Forms
  //
  openModal(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");
    if (window.room_modal_xl) {
      this.setModalContent(window.room_modal_xl, url);
    }
  }

  // create md modals(season, catalog value)
  createSeasonModal(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");
    // let reloadRoomFormVar = this.reloadRoomMainForm()
    if (window.room_modal_md) {
      this.removeBackdrops();
      this.setModalContent(window.room_modal_md, url)
      this.hideRoomModal();
      this.hideRoomTypeModal();
      // reset modal connect, remove leave page from form
    }
  }

  addReloadFormTrigger(form_element) {
    let controller;
    if (form_element) controller = this.formController(form_element)
    if (controller) {
      const is_reload_input = document.querySelector("#rooms_form_is_reload")
      if (is_reload_input) {
        is_reload_input.value = false;
        is_reload_input.addEventListener(
          "change",
          function (event) {
            if (is_reload_input.getAttribute('data-season-id')) controller.reloadRoomMainForm();
          }, false,
        );
      }

    }
  }

  formController(form_element) {
    return this.application.getControllerForElementAndIdentifier(form_element, "suppliers--rooms")
  }


  reloadRoomMainForm() {
    this.refreshSeasonsTable();

    // console.log("reloadRoomMainForm")
    // let main_form = document.querySelector("#supplier_room_form")
    // const is_reload_input = document.querySelector("#rooms_form_is_reload")
    // if (main_form && is_reload_input) {
    //   const season_id = is_reload_input.getAttribute('data-season-id')
    //   const season_name = is_reload_input.getAttribute('data-season-name')

    //   const fit_tr_template = document.querySelector("#fit_rooms_tr_template")
    //   if (fit_tr_template && season_id && season_name) {
    //     let fit_rooms_tbody = document.querySelector("#fit_rooms_tbody")
    //     let new_tr = fit_tr_template.innerHTML
    //     const index = new Date().getTime() + 1;
    //     new_tr = new_tr.replace(/NEW_RECORD_SESSON_NAME/g, season_name)
    //     new_tr = new_tr.replace(/NEW_RECORD_SEASON_ID/g, season_id)
    //     // new_tr = new_tr.replace(/NEW_RECORD_INDEX/g, fit_rooms_tbody.rows.length + 1)
    //     new_tr = new_tr.replace(/NEW_RECORD/g, index)
    //     fit_rooms_tbody.insertAdjacentHTML('beforeend', new_tr)
    //   }

    //   const grp_tr_template = document.querySelector("#grp_rooms_tr_template")
    //   if (grp_tr_template && season_id && season_name) {
    //     const index = new Date().getTime() + 39;
    //     let grp_rooms_tbody = document.querySelector("#grp_rooms_tbody")
    //     let new_tr = grp_tr_template.innerHTML
    //     new_tr = new_tr.replace(/NEW_RECORD_SESSON_NAME/g, season_name)
    //     new_tr = new_tr.replace(/NEW_RECORD_SEASON_ID/g, season_id)
    //     // new_tr = new_tr.replace(/NEW_RECORD_INDEX/g, grp_rooms_tbody.rows.length + 1)
    //     new_tr = new_tr.replace(/NEW_RECORD/g, index)
    //     grp_rooms_tbody.insertAdjacentHTML('beforeend', new_tr)
    //   }

    //   this.refreshSeasonsTable();
    // }
  }

  async refreshSeasonsTable() {
    try {
      const roomPricesElement = document.querySelector('[data-controller*="room-prices"]');
      if (roomPricesElement) {
        const roomPricesController = this.application.getControllerForElementAndIdentifier(roomPricesElement, "room-prices");
        if (roomPricesController && typeof roomPricesController.refreshSeasonsTable === 'function') {
          await roomPricesController.refreshSeasonsTable();
        }
      }
    } catch (error) {
      console.error('Error refreshing seasons table from rooms controller:', error);
    }
  }

  // create md modals(season, catalog value)
  createRoomTypeModal(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");
    if (window.room_modal_md_second) {
      this.setModalContent(window.room_modal_md_second, url);
      this.hideRoomModal();
      this.hideSeasonModal();
    }
  }

  async setModalContent(modal, url) {
    // await - https://learn.javascript.ru/async-await#await
    let content_response = await fetch(url);
    let content = await content_response.text();
    //
    // https://thednp.github.io/bootstrap.native/#componentModal
    //
    if (modal) {
      this.removeBackdrops();
      modal.setContent(content);
      modal.show();
      modal.update();
    }

  }

  onRoomChange(event) {
    let room_name = event.target.choices.getValue().label;
    let tourist_amount = 1;
    if (/([Dd]ouble|[Tt]win)/i.test(room_name)) {
      tourist_amount = 2;
    } else if (/[Tt]riple/i.test(room_name)) {
      tourist_amount = 3;
    } else if (/[Qq]uadriple/i.test(room_name)) {
      tourist_amount = 4;
    }

    if (this.tourist_amountTarget.numeric) {
      this.tourist_amountTarget.numeric.set(tourist_amount);
    } else {
      this.tourist_amountTarget.value = tourist_amount;
    }
    
    this.recalculate_table();
    
    this.updateDailyPriceEditorTouristTax();
  }

  removeBackdrops() {
    const modalsBackdrops = document.getElementsByClassName('modal-backdrop');

    // remove every modal backdrop
    for (let i = 0; i < modalsBackdrops.length; i++) {
      document.body.removeChild(modalsBackdrops[i]);
    }
  }

  hideRoomModal() {
    if (window.room_modal_xl) {
      window.room_modal_xl.hide();
      // window.room_modal_xl.update();
    }
  }

  hideSeasonModal() {
    if (window.room_modal_md) {
      window.room_modal_md.hide();
      window.room_modal_md.setContent("");
      window.room_modal_md.update();
    }
  }

  hideRoomTypeModal() {
    if (window.room_modal_md_second) {
      window.room_modal_md_second.hide();
      window.room_modal_md_second.setContent("");
      window.room_modal_md_second.update();
    }
  }

  showRoomModal() {
    if (window.room_modal_xl) {
      this.hideSeasonModal()
      this.hideRoomTypeModal()
      this.removeBackdrops();
      window.room_modal_xl.toggle();
      window.room_modal_xl.update();
    }
  }

  removeRoomModal() {
    if (window.room_modal_xl) {
      window.room_modal_xl.hide();
      window.room_modal_xl.setContent("");
      this.removeBackdrops();
    }
  }

  updateDailyPriceEditorTouristTax() {
    const dailyPriceEditor = document.querySelector('#daily_price_editor');
    if (!dailyPriceEditor || dailyPriceEditor.classList.contains('d-none')) {
      return;
    }

    const form = document.querySelector('#supplier_room_form');
    if (!form) return;
    
    const roomPricesController = this.application.getControllerForElementAndIdentifier(
      form, 
      'room-prices'
    );

    if (roomPricesController) {
      const newTouristTaxValue = this.getTouristTaxValue();
      roomPricesController.touristTaxFixedValue = newTouristTaxValue;
      
      dailyPriceEditor.dataset.roomPricesTouristTaxValue = newTouristTaxValue;
      
      roomPricesController.calculatePrice();
    }
  }

}